// src/i18n.js
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import { loadTranslations } from "./components/translations";

// Determine initial language from URL
const getInitialLanguage = () => {
  const path = window.location.pathname;
  return path.startsWith("/en") ? "en" : "it";
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: false,
    interpolation: { escapeValue: false },
    lng: getInitialLanguage(),
    fallbackLng: "it",
    ns: ["global"],
    defaultNS: "global",
    resources: {},
    react: {
      useSuspense: true, // <<< changed so that the app waits for translations
    },
    detection: {
      order: ["path", "navigator"],
      lookupFromPathIndex: 0,
      checkWhitelist: true,
    },
    whitelist: ["en", "it"],
  });

// Load initial translations
const loadInitialTranslations = async () => {
  try {
    const initialLang = getInitialLanguage();
    const translations = await loadTranslations(initialLang);
    i18n.addResourceBundle(initialLang, "global", translations, true, true);
  } catch (error) {
    console.error("Error loading initial translations:", error);
  }
};

const ready = loadInitialTranslations();

export default i18n;
export { ready };
